<template>
  <div>
    <a-card
      size="small"
      title="查询"
      :headStyle="{
        background: '#f3f3f3',
      }"
    >
      <a-form layout="inline">
        <a-form-item>
          <a-input
            placeholder="菜单名称"
            v-model:value="searchForm.name"
            allowClear
            @keyup.enter.native="searchAction()"
          />
        </a-form-item>

        <a-form-item>
          <a-button type="primary" @click="searchAction"> 查询</a-button>
        </a-form-item>
        <a-form-item>
          <a-button @click="reset">重置</a-button>
        </a-form-item>
        <a-form-item></a-form-item>
      </a-form>
    </a-card>

    <a-card
      size="small"
      title="菜单列表"
      style="margin-top: 20px"
      :headStyle="{
        background: '#f3f3f3',
      }"
      :bodyStyle="{
        padding: '0',
      }"
    >
      <template v-slot:extra>
        <a-button
          @click="toAdd"
          type="primary"
          v-has-permi="['system:menu:add']"
          >添加</a-button
        >
      </template>

      <a-table
        :columns="columns"
        bordered
        :data-source="list"
        :row-key="(r) => r.menuId"
        :loading="loading"
      >
        <template v-slot:icon="{ text, record, index }">
          <icon-font :type="record.icon" />
        </template>

        <template v-slot:button="{ text, record }">
          <a-button
            type="primary"
            @click="edit(record)"
            v-has-permi="['system:menu:edit']"
          >
            编辑</a-button
          >
        </template>
      </a-table>
    </a-card>

    <!--    <df-pagination :model="pageObj"></df-pagination>-->

    <a-modal
      v-model:visible="modalVisible"
      title="添加菜单"
      @ok="handleOk"
      :destroyOnClose="true"
    >
      <!-- @ok="handleOk" -->
      <a-form
        layout="horizontal"
        :ref="setsubmitForm"
        :model="submitForm"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-item label="上级菜单" name="parentId">
          <df-selectMenuTreeSingleClone
            :model="submitForm"
            @setValue="setValue"
            style="width: 282px"
          />
        </a-form-item>
        <a-form-item label="菜单类型" name="menuType">
          <a-radio-group
            v-model:value="submitForm.menuType"
            button-style="solid"
            default-value="1"
            @change="menuTypeChange"
          >
            <a-radio-button :value="0"> 目录</a-radio-button>
            <a-radio-button :value="1"> 菜单</a-radio-button>
            <a-radio-button :value="2"> 按钮</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="菜单图标" name="icon" v-if="!isButton">
          <a-input
            v-model:value="submitForm.icon"
            placeholder="菜单图标"
            style="width: 282px"
          />
        </a-form-item>
        <a-form-item label="菜单名称" name="name">
          <a-input
            v-model:value="submitForm.name"
            placeholder="菜单名称"
            style="width: 282px"
          />
        </a-form-item>
        <a-form-item
          label="路由地址"
          name="component"
          v-if="!isButton && !isCatalogue"
        >
          <a-input
            v-model:value="submitForm.component"
            placeholder="路由地址"
            style="width: 282px"
          />
        </a-form-item>
        <a-form-item
          label="组件路径"
          name="path"
          v-if="!isButton && !isCatalogue"
        >
          <a-input
            v-model:value="submitForm.path"
            placeholder="组件路径"
            style="width: 282px"
          />
        </a-form-item>
        <a-form-item label="权限标识" name="perms">
          <a-input
            v-model:value="submitForm.perms"
            placeholder="权限标识"
            style="width: 282px"
          />
        </a-form-item>
        <a-form-item label="菜单排序" name="sort">
          <a-input-number
            v-model:value="submitForm.sort"
            placeholder="排序"
            :min="1"
            :max="100"
            style="width: 282px"
          />
        </a-form-item>
        <a-form-item label="菜单状态" name="main" v-if="!isButton">
          <a-radio-group
            v-model:value="submitForm.status"
            button-style="solid"
            default-value="0"
          >
            <a-radio-button value="0"> 开启</a-radio-button>
            <a-radio-button value="1"> 关闭</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="是否外链" name="main" v-if="!isButton">
          <a-radio-group
            v-model:value="submitForm.isFrame"
            button-style="solid"
            default-value="0"
          >
            <a-radio-button value="0"> 是</a-radio-button>
            <a-radio-button value="1"> 否</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="显示状态" name="main" v-if="!isButton">
          <a-radio-group
            v-model:value="submitForm.visible"
            button-style="solid"
            default-value="0"
          >
            <a-radio-button value="0"> 显示</a-radio-button>
            <a-radio-button value="1"> 隐藏</a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import staticof from "@assets/static";
import { ref, reactive, provide } from "vue";
import { notification } from "ant-design-vue";
import { SmileOutlined } from "@ant-design/icons-vue";
import moment from "moment";
import { createFromIconfontCN } from "@ant-design/icons-vue";

const IconFont = createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/font_2033419_extitw862n.js",
});
import menu from "@axios/sysmenu";
export default {
  name: "menuIndex",
  components: {
    IconFont,
  },
  setup() {
    let submitFormref = "";
    const setsubmitForm = (el) => {
      submitFormref = el;
    };

    let submitForm = reactive({
      pid: null,
      name: "",
      path: "",
      component: "",
      menuType: 0,
      permission: "",
      icon: "",
      status: 0,
      isFrame: "1",
      sort: "1",
    });
    //目录
    let isCatalogue = ref(true);
    //菜单
    let isMenu = ref(false);
    //按钮
    let isButton = ref(false);
    //切换菜单类型
    const menuTypeChange = (e) => {
      typeChange(e.target.value);
    };
    //切换（M目录 C菜单 F按钮）
    const typeChange = (menuType) => {
      if (menuType == "0") {
        isCatalogue.value = true;
        isMenu.value = false;
        isButton.value = false;
      }
      if (menuType == "1") {
        isCatalogue.value = false;
        isMenu.value = true;
        isButton.value = false;
      }
      if (menuType == "2") {
        isCatalogue.value = false;
        isMenu.value = false;
        isButton.value = true;
      }
    };

    const rules = {
      name: [{ required: true, message: "请输入菜单名称", trigger: "blur" }],
      // parentId: [
      //   { required: true, message: "请输入选择上级菜单", trigger: "blur" },
      // ],
      component: [
        { required: true, message: "请输入权限字符", trigger: "blur" },
      ],
    };

    let loading = ref(false);
    let modalVisible = ref(false);
    let searchForm = reactive({
      name: "",
    });
    let searchParams = reactive({
      name: "",
    });

    let names = ref("");

    let list = ref([]);

    const columns = [
      {
        title: "菜单名称",
        dataIndex: "name",
        width: 200,
      },
      {
        title: "图标",
        dataIndex: "icon",
        width: 200,
        align: "center",
        slots: { customRender: "icon" },
      },
      {
        title: "菜单排序",
        dataIndex: "sort",
        width: 100,
        align: "center",
      },
      {
        title: "权限标识",
        dataIndex: "permission",
        width: 200,
        align: "center",
      },
      {
        title: "组件路径",
        dataIndex: "component",
        width: 200,
        align: "center",
      },
      {
        title: "状态",
        dataIndex: "number",
        width: 200,
        align: "center",
      },
      {
        title: "创建时间",
        dataIndex: "createTime",
        width: 200,
        align: "center",
      },
      {
        title: "操作",
        dataIndex: "createTime",
        width: 100,
        align: "center",
        slots: { customRender: "button" },
      },
    ];

    const searchAction = () => {
      searchParams.name = searchForm.name;
      console.log(searchParams);
      getList();
    };
    //获取菜单列表
    const getList = () => {
      loading.value = true;
      let params = {
        name: searchParams.name ? searchParams.name : null,
      };
      menu.menuList(params).then((res) => {
        loading.value = false;
        if (!res) return;
        list.value = res;
      });
    };

    const reset = () => {
      searchForm.name = "";
      searchAction();
    };

    const toAdd = () => {
      modalVisible.value = true;
      isedit.value = false;
      isCatalogue.value = true;
      isMenu.value = false;
      isButton.value = false;
      submitForm.parentId = "";
      submitForm.name = "";
      submitForm.status = 0;
      submitForm.isFrame = "1";
      submitForm.visible = "0";
      submitForm.path = "";
      submitForm.menuType = 1;
      submitForm.perms = "";
      submitForm.icon = "";
      submitForm.sort = "1";
    };

    const handleOk = () => {
      submitFormref
        .validate()
        .then(() => {
          //如果id存在,编辑
          if (rowId.value) {
            let params = {
              id: rowId.value,
              pid: submitForm.parentId,
              name: submitForm.name,
              status: submitForm.status,
              isFrame: submitForm.isFrame,
              visible: submitForm.visible,
              path: submitForm.path,
              type: Number(submitForm.menuType),
              permission: submitForm.perms,
              icon: submitForm.icon,
              sort: submitForm.sort,
            };
            menu.menuUpdate(params).then((res) => {
              modalVisible.value = false;
              getList();
              notification.open({
                message: "编辑成功",
                icon: <SmileOutlined style="color: #108ee9" />,
              });
            });
          } else {
            //id不存在就是增加
            menu.menuInsert(submitForm).then((res) => {
              modalVisible.value = false;
              getList();
              notification.open({
                message: "添加成功",
                icon: <SmileOutlined style="color: #108ee9" />,
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    //上级菜单值
    const setValue = (val) => {
      console.log(val);
      submitForm.parentId = val;
    };

    let isedit = ref(false);
    let editid = "";
    let rowId = ref("");
    const edit = (row) => {
      if (submitFormref) submitFormref.resetFields();
      rowId.value = row.id;
      editid = row.menuId;
      isedit.value = true;
      modalVisible.value = true;
      submitForm.parentId = row.pid;
      submitForm.name = row.name;
      submitForm.status = row.status;
      submitForm.isFrame = row.isFrame;
      submitForm.path = row.path;
      submitForm.menuType = row.type;
      submitForm.perms = row.perms;
      submitForm.icon = row.icon;
      submitForm.sort = row.sort;
      typeChange(row.menuType);
    };

    getList();

    return {
      rowId,
      isedit,
      edit,
      names,
      staticof,
      loading,
      searchForm,
      searchParams,
      list,
      columns,
      searchAction,
      reset,
      toAdd,
      modalVisible,
      moment,
      disabledDate(current) {
        return current && current < moment().endOf("day");
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      rules,
      submitForm,
      handleOk,
      setsubmitForm,
      setValue,
      menuTypeChange,
      isCatalogue,
      isMenu,
      isButton,
    };
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.ant-table-body {
  overflow: auto;
}
.table_logo {
  width: 70px;
}
/deep/ .ant-card-body {
  overflow: auto;
}
</style>



